import React, { useEffect } from 'react'

import { APARTMENT, VENDOR } from '../../../../helpers'
import { useUser } from '../../../../hooks'
import { VendorItems } from '../../../components/SideBarItems/VendorItems'
import { ApartmentItems } from '../../../components/SideBarItems/ApartmentItems'
import { useLocation } from 'react-router-dom'
import { navigationConfig } from '../../../config/navigationItems'
import { Routes } from '../../../config/routes'
import { OrganizationItems } from '../../../components/SideBarItems/OrganizationItems'
import { ManageItems } from '../../../components/SideBarItems/ManageItems'
import { manageRoutes } from '../../../routes/manageRoutes'
import {
    getActiveNavApp,
    setActiveNavApp,
} from '../../../utils/activeAppContext'

// Helper function to match routes properly
const matchRoute = (currentPath: string, routePath: string): boolean => {
    // Remove trailing slashes for consistent comparison
    const normalizedCurrentPath = currentPath.replace(/\/+$/, '')
    const normalizedRoutePath = routePath.replace(/\/+$/, '')

    // Remove any numeric or parameter segments from both paths
    const cleanCurrentPath = normalizedCurrentPath
        .split('/')
        .filter((part) => !part.match(/^\d+$/) && !part.startsWith(':'))
        .join('/')

    const cleanRoutePath = normalizedRoutePath
        .split('/')
        .filter((part) => !part.match(/^\d+$/) && !part.startsWith(':'))
        .join('/')

    // Compare the cleaned paths
    return cleanCurrentPath === cleanRoutePath
}

const SideBarNavigationItems = () => {
    const { workspaceUser } = useUser()

    const location = useLocation()

    /** Nested subs routes (e.g. /subs/pricing) are not in navigationConfig; still vendor EZTurn. */
    const isVendorSubsSection =
        location.pathname === Routes.vendor.subs ||
        location.pathname.startsWith(`${Routes.vendor.subs}/`)

    const isDailyActivity = location.pathname.startsWith(
        Routes.apartment.dailyActivity.root,
    )
    const isRecords = location.pathname.startsWith(
        Routes.apartment.records.root,
    )
    const isAboveLinePage = isDailyActivity || isRecords

    const isEZTurnFromRoute = [
        ...navigationConfig.apartment.mainItems,
        ...navigationConfig.apartment.footerItems,
        ...navigationConfig.vendor.mainItems,
        ...navigationConfig.vendor.footerItems,
        ...navigationConfig.shared.mainItems,
        ...navigationConfig.shared.footerItems,
    ].some((item) => matchRoute(location.pathname, item.link))

    const isEZFolioSelected = [
        ...navigationConfig.organization.mainItems,
        ...navigationConfig.organization.footerItems,
    ].some((item) => matchRoute(location.pathname, item.link))

    const isManageFromRoute = [
        ...navigationConfig.manage.mainItems,
        ...navigationConfig.manage.footerItems,
        ...manageRoutes.map((route) => ({ link: route.path })),
    ].some((item) => matchRoute(location.pathname, item.link))

    useEffect(() => {
        if (isAboveLinePage) return
        if (isManageFromRoute) {
            setActiveNavApp('manage')
        } else if (isEZTurnFromRoute || isVendorSubsSection) {
            setActiveNavApp('ezturn')
        }
    }, [
        isAboveLinePage,
        isManageFromRoute,
        isEZTurnFromRoute,
        isVendorSubsSection,
    ])

    const persistedApp = getActiveNavApp()
    const isEZTurnSelected = isAboveLinePage
        ? persistedApp !== 'manage'
        : isEZTurnFromRoute
    const isManageSelected = isAboveLinePage
        ? persistedApp === 'manage'
        : isManageFromRoute

    if (!workspaceUser) return null

    if (
        workspaceUser.active_workspace.company_type === VENDOR &&
        (isEZTurnSelected || isVendorSubsSection)
    ) {
        return <VendorItems />
    }

    if (
        workspaceUser.active_workspace.company_type === APARTMENT &&
        isEZTurnSelected
    ) {
        return <ApartmentItems />
    }

    // if (isAdminSelected) {
    //     return <AdminItems />
    // }

    if (isManageSelected) {
        return <ManageItems />
    }

    if (isEZFolioSelected) {
        return <OrganizationItems />
    }

    return <ApartmentItems />
}

export default SideBarNavigationItems
